/* eslint-disable dot-notation */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import eventBus from './EventBus';

export default () => {
  const [popupShown, setShowPopup] = useState(false);
  useEffect(() => {
    const notAccepted = !localStorage['termsAccepted'];
    if (notAccepted) {
      setShowPopup(true);
      eventBus.dispatch('cookiesPopupActive', { value: true });
    }
  }, []);

  const closePopup = () => {
    localStorage['termsAccepted'] = true;
    setShowPopup(false);
    eventBus.dispatch('cookiesPopupActive', { value: false });
  };
  return (
    <div>
      {popupShown === true && (
        <div>
          <div className="cookie-alert">
            <div className="container">
              <div className="cookie-body justify-content-center">
                <div className="body">
                  We use cookies on our website. For more details, please read
                  our{' '}
                  <Link to="/privacy-policy/" className="link">
                    Privacy Policy
                  </Link>
                  .<br className="break" /> By using this website, you consent
                  to the use of cookies.
                  <span
                    onClick={closePopup}
                    onKeyDown={closePopup}
                    role="button"
                    tabIndex={0}
                    className="cookie-button-accept"
                  >
                    Accept
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
